nodeIsDate